import { PaymentSystem } from "@/domains/profile/types";
import {
  HttpRequestParams,
  HttpResponseAxiosDataType,
  HttpResponseAxiosErrorType,
} from "@/types/http";
import { profileKeys } from "@/domains/profile/apiKeys";
import useSWR from "swr";
import { profileApi } from "@/domains/profile/service";
import { useStore } from "@/hooks/use-store";

type UseGetTransactionsType = {
  loading: boolean;
  paymentSystems: {
    in: PaymentSystem[];
    out: PaymentSystem[];
  };
};

const fetcher = (payload: HttpRequestParams<void>) => () => profileApi.getPaymentSystems(payload);

export const useGetPaymentSystems = (): UseGetTransactionsType => {
  const { user } = useStore();

  const { data, isLoading, isValidating } = useSWR<
    HttpResponseAxiosDataType<PaymentSystem[]>,
    HttpResponseAxiosErrorType
  >(
    [profileKeys.getPaymentSystems],
    fetcher({
      configOptions: { headers: { Authorization: `Bearer ${user.getToken()}` } },
    }),
  );

  const inPayments =
    data?.data.filter((p: { type: string }) => p.type === "in") || ([] as PaymentSystem[]);
  const outPayments =
    data?.data.filter((p: { type: string }) => p.type === "out") || ([] as PaymentSystem[]);

  return {
    loading: isLoading || isValidating,
    paymentSystems: {
      in: inPayments,
      out: outPayments,
    },
  };
};
